<template>
  <LayoutAdmin :active-periode="activePeriodic">
    <section class="md:px-8 px-4 mt-6 w-full">
      <section class="flex items-center mb-10">
        <h1 class="text-lg md:text-2xl">App Settings</h1>
        <ChoiseCompany
          v-if="!loading.company && options.length"
          @selected:company="dataCompany = $event"
          :options="options"
          :dataCompany="dataCompany"
        />
      </section>
      <section class="flex justify-between flex-col md:flex-row w-full h-auto mb-6">
        <section class="w-full bg-white">
          <AppSettingTable v-if="sideTabActive === 'Leave Type'" />
        </section>
      </section>
    </section>
  </LayoutAdmin>
</template>

<script>
import LayoutAdmin from "../../components/Layout/Admin.vue";
import AppSettingTable from "@/components/AppSettingTable.vue";
import ChoiseCompany from "@/components/ChoiseCompany.vue";
import { GetAllCompanyEmployeeOptionsAPI } from "@/actions/company";
import { GetPeriodicActiveAPI } from "@/actions/periodic";
import decryptToken from "@/utils/decryptToken";

export default {
  name: "LeaveSetting",
  components: {
    LayoutAdmin,
    AppSettingTable,
    ChoiseCompany,
  },
  data() {
    return {
      activePeriodic: "-",
      titleTabs: [{ name: "Leave Type" }],
      sideTabActive: "Leave Type",
      personal_detail: {
        company_id: "",
      },
      superAdmin: false,
      options: [],
      dataCompany: {},
      loadingData: false,
      loading: {
        company: true,
      },
    };
  },
  methods: {
    async getAllCompany() {
      const response = await GetAllCompanyEmployeeOptionsAPI();
      this.options = response?.data;
      this.dataCompany = response?.data[0];
      this.loading.company = false;
    },
    async handleGetPeriodicActive() {
      const querySuperAdmin = `?company_id=${this?.dataCompany?._id}`;
      const response = await GetPeriodicActiveAPI(querySuperAdmin);
      if (response?.status === 401) {
        this.$router.push("/login");
        this.$store.commit("changeIsLoggedIn", false);
      }
      console.log(response?.data);
      this.activePeriodic = response?.data?.periodic_month + " (" + response?.data?.periodic_start_date + " to " + response?.data?.periodic_end_date + ")";
    },
  },
  watch: {
    dataCompany: {
      handler: function () {
        this.handleGetPeriodicActive();
      },
      deep: true,
    },
  },
  mounted() {
    const payload = decryptToken();
    this.superAdmin = payload?.role === "Super Admin";
    this.getAllCompany();
  },
};
</script>

<style scoped>
.profile {
  min-width: 128px;
  min-height: 128px;
}
</style>
